.media-minimal-skin .media-buffering-indicator {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: none;
  place-content: center;
  color: oklch(1 0 0);
  pointer-events: none;

  &::before {
    position: absolute;
    inset: 0;
    content: "";
    background: oklch(0 0 0 / 0.35);
    backdrop-filter: blur(8px);
  }

  > * {
    position: relative;
    z-index: 20;
  }

  &:not([data-visible]) {
    --media-spinner-animation: none;
  }

  &[data-visible] {
    display: grid;
  }

  @media (prefers-reduced-motion: reduce) {
    --media-spinner-animation: none;
  }
}
